export default {
  'footer.html': `<p data-testid="footer-terms-pp">
  By using this form you agree with our&nbsp;
  <a href="https://www.qbe.com/au/about/governance/website-terms" target="_blank" rel="noopener noreferrer">
    Website Terms
  </a>
  &nbsp;and&nbsp;
  <a href="https://www.qbe.com/au/about/governance/privacy-policy" target="_blank" rel="noopener noreferrer">
    Privacy Statement{' '}
  </a>
</p>`,
  'landing.form.heading': 'What do you want to do?',
  'landing.form.contentParagraph':
    'We want to resolve your complaint as quickly as possible. To assist us in this process we need some details from you.',
  'landing.form.contentInformation':
    'If you prefer to talk to one of our team members, call our Customer Relations team on 1300 650 503 or get started below.',
  'provider.form.heading': 'What do you want to do?',
  'provider.form.contentParagraph':
    'Use this form to report complaints, incidents/breaches or lodge a financial hardship application.',
  'provider.form.lodgementType': 'Select the type of lodgement you want to complete',
  'provider.form.lodgement.0.label': 'Complaint',
  'provider.form.lodgement.1.label': 'Financial hardship application',
  'provider.form.lodgement.2.label': 'Incident/Breach',
  'provider.form.submit.label': 'Continue',

  'consent.insured.form.heading': 'Tell us about you',
  'consent.contactReason.heading': 'Contact Reason',
  'consent.contactReason.sectionHeading': 'Are you contacting us about a claim or a policy?',
  'consentForm.options.0.text': 'Claim',
  'consentForm.options.1.text': 'Policy',
  'consent.contactReason.policyNumber': 'What is the policy number?',
  'consent.contactReason.claimNumber': 'What is the claim number?',
  'consent.contactReason.contactInformation':
    'If you do not have all the information or if you need assistance, please call us on 1300 650 503.',
  'consent.contactReason.policyNumber.infoText':
    'You can find the policy number on the top right corner of the policy documents.',
  'consent.contactReason.claimNumber.infoText':
    'You can find the claim number on any claim documents that have been provided to you.',
  'consent.contactReason.webformInformation':
    'Please note, this webform is for partners to notify us about a complaint, if you have a complaint yourself please call us.',
  'consent.personalDetails.heading': 'Your details',
  'consent.personalDetails.relationship': 'Who are you?',
  'consent.personalDetails.relationshipInfoText':
    'Please select the role that reflects your relationship with QBE. If you’re not sure, please contact your QBE relationship manager.',
  'consent.personalDetails.name': 'Please enter your name',
  'consent.personalDetails.organisation': 'What is the name of your organisation?',
  'consent.personalDetails.organisation.label': 'Organisation',
  'consent.contactDetails.heading': 'Contact details',
  'consent.contactDetails.email': 'Please enter your email address',
  'consent.contactDetails.emailAddress.label': 'Email address',
  'consent.contactDetails.phoneNumber': 'Please enter your phone number',
  'consent.contactDetails.phoneNumber.label': 'Phone number',
  'consent.contactDetails.contactTypeField.information':
    'I will be the contact for the complaint on behalf of the customer',
  'consent.contactDetails.contactTypeField.details':
    'If you select ‘Yes’ you will be the primary contact for this complaint and responsible for communicating with the customer.',
  'consent.contactDetails.preferedContactType': 'What is your preferred method of contact?',
  'consent.contactDetails.preferedContactType.infoText':
    'Collecting your details means that we can contact you the way you want us to about this complaint.',
  'consent.contactDetails.postalAddress': 'What is your postal address?',

  'insured.form.heading': 'Tell us about your customer',
  'insured.customerDetails.heading': 'Customer’s details',
  'insured.customerDetails.sectionHeading': 'Is the customer an individual or a business?',
  'insured.individualOrBusiness.0.text': 'Individual',
  'insured.individualOrBusiness.1.text': 'Business',
  'insured.personalDetails.section': 'Insured details',
  'insured.personalDetails.title': 'What is your title',
  'insured.personalDetails.name': 'Please enter your name',
  'insured.customerDetails.customerTitle': 'Customer’s title',
  'insured.customerDetails.customerTitle.label': 'Title',
  'insured.customerDetails.customerName': 'Please enter the customer’s name',
  'insured.customerDetails.dob': 'Date of birth',
  'insured.customerDetails.dob.infoText': 'If you do not know the customer’s date of birth, please enter 01/01/1900',
  'insured.customerDetails.gender': 'Gender',
  'insured.customerDetails.contactPersonTitle': 'Contact person’s title',
  'insured.customerDetails.contactPersonName': 'Please enter the contact person’s name',
  'insured.contactDetails.heading': 'Contact details',
  'insured.contactDetails.preferedMethod': 'What is the customer’s preferred method of contact?',
  'insured.contactDetails.preferedMethod.inofText':
    'Collecting these details means that we can contact the customer the way they want us to about this complaint',
  'insured.contactDetails.emailAddress': 'What is the customer’s email address?',
  'insured.contactDetails.residentialAddress': 'What is the customer’s residential address?',
  'insured.contactDetails.addressType': 'Is the customer’s postal address the same as their residential address?',
  'insured.contactDetails.phoneNumber': 'What is the customer’s contact number?',

  'insured.otherDetails.heading': 'Other Details',
  'insured.otherDetails.vulnerability': 'Is the customer experiencing vulnerability?',
  'insured.otherDetails.vulnerability.infoText':
    'Vulnerability can result in difficulty making informed decisions due to their circumstances, which could be either permanent or temporary.',
  'insured.otherDetails.vulnerabilityInfo': 'What is the vulnerability?',
  'insured.otherDetails.languageInterpreter': 'Is a language interpreter required?',
  'insured.otherDetails.language': 'What is the language?',
  'insured.otherDetails.languageType': 'Please enter the language',
  'insured.otherDetails.isAboriginal': 'Is the customer Aboriginal and/or Torres Strait Islander?',
  'insured.otherDetails.information':
    'Please provide any other information that is important for us to know about the customer.',
  'insured.otherDetails.businessName': 'What is the customer’s business name?',
  'insured.otherDetails.isSmallBusiness':
    'Is the customer operating a small business? (Defined as having 100 employees or less)',
  'insured.otherDetails.businessInfoText': 'The legal name that the business operates under.',
  'insured.otherDetails.smallBusiness.infoText': 'Defined as having 100 employees or less.',
  'insured.otherDetails.vulnerabilityReason.label': 'Reason for vulnerability',
  'insured.otherDetails.language.label': 'Language',
  'insured.otherDetails.otherLanguage.label': 'Other language',
  'insured.otherDetails.customerDesc.label': 'Please type here',
  'insured.otherDetails.businessName.label': 'Business name',

  'complaint.form.heading': 'Tell us more',
  'complaint.details.heading': 'Complaint information',
  'complaint.details.complaintDate': 'When was the complaint raised with you?',
  'complaint.details.sourceOfComplaint': 'How did you receive the complaint?',
  'complaint.details.acknowledgement': 'Have you acknowledged receipt of the complaint?',
  'complaint.details.acknowledgement.infoText':
    'Complaint acknowledgments must be in writing to the customer, this may be in an email or letter',
  'complaint.details.acknowledgementDate': 'When did you acknowledge receipt of the complaint?',
  'complaint.details.product': 'Which product does the complaint relate to?',
  'complaint.details.complaintDescription': 'Please provide a description of the complaint',
  'complaint.details.complaintType': 'Which of the below does the complaint relate to?',
  'complaint.details.compType.sales.text': 'Sales',
  'complaint.details.compType.claims.text': 'Claims',
  'complaint.details.compType.finHard.text': 'Financial hardship application',
  'complaint.details.complaintCategory': 'Please select one or two categories that best relate to this complaint?',
  'complaint.details.isSensitive': 'Is this a sensitive complaint?',
  'complaint.details.isResolved': 'Have you resolved this complaint with the customer?',
  'complaint.details.isResolved.infoText':
    'Resolved means that the customer complaint was closed to their satisfaction and there is no further action needed.',
  'complaint.details.resolvedDate': 'What is the date the complaint was resolved?',
  'complaint.details.customer.desiredOutcome': 'What is the customer’s desired outcome of this complaint?',
  'complaint.details.complaint.outcome': 'What is the outcome of the complaint?',
  'complaint.details.outcomeDescription': 'Describe the outcome in further detail',
  'complaint.details.amountInDispute': 'If applicable, what is the amount in dispute?',
  'complaint.details.amountInDispute.label': 'Amount in dispute',
  'complaint.details.amountResolved.label': 'Amount resolved',
  'complaint.details.amountResolved': 'How much money was paid to resolve the complaint?',
  'complaint.details.sensitive.infoText':
    'Select ‘yes’ if the customer is a QBE employee, public figure, high profile figure, or the information must be kept private for security reasons.',
  'complaint.details.complaintType.infoText':
    'This information helps us ensure the right person handles the complaint. ',
  'complaint.details.complaintCategory.infoText':
    'This information helps us ensure the right person handles the complaint.',
  'attachment.title': 'Attachments',
  'attachment.subtitle': 'Attach supporting material here',
  'attachment.addFiles': 'Add files',
  'attachment.limit': 'MB limit',
  'attachment.infoText': 'Allowed file types are:',
  'success.form.content':
    'Thanks for contacting QBE. We’ll review the information you have provided and get back to you as soon as we can.',
  'success.form.content.breach':
    'Thank you for contacting QBE. When we have reviewed the information provided, you will be contacted should any further details be required.',
  'success.form.content.title': 'Thank you',

  'fha.contactUs.text': 'Contact QBE Financial Hardship Support on 1300 902 417',
  'fha.your.details.personalDetails.heading': 'Personal details',
  'fha.your.details.application.reason': 'Is the application about a claim or a policy?',
  'fha.your.details.application.info':
    'If you do not have all the information or if you need assistance, please call us on 1300 902 417.',
  'fha.your.details.claim': 'What is the claim number?',
  'fha.your.details.policy': 'Please provide the policy number',
  'fha.your.details.relationship.info':
    'Please select the role that reflects your relationship with QBE. If you’re not sure, please contact your QBE relationship manager.',
  'fha.your.details.policyError.title': 'For Policy related assistance',
  'fha.your.details.policyError.message':
    'Please contact QBE Financial Hardship Support for assistance on 1300 902 417',
  'fha.your.details.policyError.alert': ` <p>
  <strong> Lenders Mortgage Insurance </strong> – go to LMI&nbsp;
  <a
    href="https://www.qbe.com/media/qbe/apac/lenders-mortgage-insurance/files/hardship-repayment-assistance-changes.pdf"
    target="_blank"
    rel="noopener noreferrer"
  >
    Hardship Assistance
  </a>
  &nbsp;
</p>

<p>
  <strong> Business insurance bought through a broker </strong> - please contact your Partnership Manager for
  further assistance
</p>
<p>
  <strong> Insurance premiums </strong> - call 133 723 Mon-Fri 8am-8pm, Sat 8am-1.30pm (AEST/ADST).
</p>`,

  'fha.your.details.contactNumber': 'Please enter your contact number',
  'fha.your.details.email': 'Please enter your email address',
  'fha.your.details.organisation': 'What is the name of your organisation?',
  'fha.your.details.name': 'Please enter your name',
  'fha.your.details.relationship': 'Who are you?',
  'fha.your.details.contactReason.claimNumber.infoText':
    'You can find the claim number on any claim documents that have been provided to you.',
  'fha.your.details.claimOrPolicy': 'Is the application about a claim or a policy?',
  'fha.your.details.heading': 'Personal Details',

  'fha.insured.personalDetails.title': 'What is the customer’s title?',
  'fha.insured.personalDetails.name': 'Please enter the customer’s name',
  'fha.insured.customer.dependents': 'Please add the customer’s dependents',
  'fha.insured.customer.dependents.infoText':
    'This is a person who the customer is legally and/or financially responsible for',
  'fha.insured.customer.dependents.heading': 'Dependent information',
  'fha.insured.customer.dependents.btn': 'Add dependents',

  'fha.insured.customer.dependentItem.name': 'Name:',
  'fha.insured.customer.dependentItem.age': 'Age:',

  'fha.contact.details.stepHeader': 'Tell us about the customer',
  'fha.contact.details.header': 'Contact details',
  'fha.contact.details.preferredContact': 'What is the customer’s preferred method of contact?',
  'fha.contact.details.preferredContactInfo':
    'Collecting these details means that we can contact the customer the way they want us to about this application',
  'fha.contact.details.email': 'What is the customer’s email address?',
  'fha.contact.details.physicalAddress': 'What is the customer’s residential address?',
  'fha.contact.details.addressType': 'Is the customer’s postal address the same as their residential address?',
  'fha.contact.details.contactNumber': 'What is the customer’s contact number?',

  'fha.tell.us.more.stepHeader': 'Tell us more',
  'fha.tell.us.more.hardship.header': 'Hardship details',
  'fha.tell.us.more.hardship.dateOfApplication': 'When was the financial hardship application raised with you?',
  'fha.tell.us.more.hardship.doa.placeholder': 'Date of application',
  'fha.tell.us.more.hardship.sourceOfApplication': 'How did you receive the application?',
  'fha.tell.us.more.hardship.soa.placeholder': 'Source of application',
  'fha.tell.us.more.hardship.reason': 'What is the reason for the customer’s application?',
  'fha.tell.us.more.hardship.reason.placeholder': 'Circumstances of hardship',
  'fha.tell.us.more.hardship.assistance': 'What assistance would the customer like QBE to consider?',
  'fha.tell.us.more.hardship.assistance.placeholder': 'Nature of assistance',
  'fha.tell.us.more.hardship.description': 'Please provide a description of the assistance required',
  'fha.tell.us.more.hardship.description.placeholder': 'Description of assistance ',

  'fha.employment.details.heading': 'Employment',
  'fha.employment.details.preview.heading': 'Employment summary',
  'fha.employment.details.section.heading': 'Employment details',
  'fha.employment.details.employmentHeading': 'Employment Details',
  'fha.employment.details.employmentStatus': 'Is the customer currently employed?',
  'fha.employment.details.employmentType': 'Please select the type of employment',
  'fha.employment.details.employmentType.label': 'Employment type',
  'fha.employment.details.employerName': 'Enter the business name of their employer',
  'fha.employment.details.employerName.label': 'Company name',
  'fha.employment.details.occupation': 'Enter their occupation',
  'fha.employment.details.occupation.label': 'Occupation',
  'fha.employment.details.contactPerson': 'Enter the contact name for this employer',
  'fha.employment.details.contactPerson.label': 'Contact person',
  'fha.employment.details.contactPersonNumber': 'Enter the contact phone number for this employer',
  'fha.employment.details.contactPersonNumber.label': 'Contact number',
  'fha.employment.details.salary': 'How much does the customer earn per month from this employer?',
  'fha.employment.details.salary.label': 'Net earnings per month',
  'fha.employment.details.salaryInfo':
    'Net earnings is the amount received after all deductions e.g. tax, superannuation',
  'fha.employment.details.addEmployer.label': 'Add another employer',
  'fha.employment.details.removeEmployer.label': 'Remove',

  'fha.employment.summary.employmentType': 'Employment type',
  'fha.employment.summary.employerName': 'Employer name',
  'fha.employment.summary.occupation': 'Occupation',
  'fha.employment.summary.contactPerson': 'Contact person',
  'fha.employment.summary.contactPersonNumber': 'Contact number',
  'fha.employment.summary.salary': 'Earnings per month',

  'fha.details.attachment.infoText': 'Allowed file types are:',

  'breach.your.details.header': 'Tell us about you',
  'breach.personal.details.heading': 'Personal Details',
  'breach.personal.details.relationship': 'What is your relationship to QBE?',
  'breach.personal.details.qbeBusiness': 'Which QBE business are you appointed by?',
  'breach.personal.details.qbeBusiness.label': 'QBE Business',

  'breach.tell.us.more.header': 'Tell us more',
  'breach.tell.us.more.heading': 'Incident/Breach Type',
  'breach.tell.us.more.breachType': 'Select the type of incident/breach you want to report',
  'breach.tell.us.more.breachType.placeholder': 'Incident/Breach type',

  'breach.tell.us.more.rootCause': 'Root Cause',
  'breach.tell.us.more.rootCause.heading': 'Select the root cause of the incident/breach',
  'breach.tell.us.more.selectAll': 'Select all that apply',

  'breach.tell.us.more.breachDetails.heading': 'Incident/Breach Details',
  'breach.tell.us.more.breachDetails.dateOccured': 'When did the incident/breach occur?',
  'breach.tell.us.more.breachDetails.dateDiscovered': 'When was the incident/breach discovered?',
  'breach.tell.us.more.breachDetails.breachDescription': 'Please provide a description of the incident/breach',
  'breach.tell.us.more.breachDetails.breachDescription.label': 'Description',
  'breach.tell.us.more.breachDetails.gicopArea': 'Which area of the Code does this incident/breach relate to?',
  'breach.tell.us.more.breachDetails.gicopArea.placeholder': 'Area of GICOP',
  'breach.tell.us.more.breachDetails.tmd': 'Please provide details regarding TMD, including:',
  'breach.tell.us.more.breachDetails.tmd.label': 'Description',
  'breach.tell.us.more.breachDetails.tmd.one': 'What is the TMD set by QBE?',
  'breach.tell.us.more.breachDetails.tmd.two': 'Why is dealing outside of TMD?',
  'breach.tell.us.more.breachDetails.tmd.three':
    'Distribution method e.g. online, face to face, telephone inbound/outbound.',
  'breach.tell.us.more.breachDetails.tmd.four': 'Advice model e.g. general advice, personal advice or no advice.',
  'breach.tell.us.more.breachDetails.dataPrivacy': 'What kind(s) of personal information was involved?',
  'breach.tell.us.more.breachDetails.dateOccured.infoText':
    'If this happened over a period of time, provide the date of the first occurrence',
  'breach.tell.us.more.breachDetails.dataPrivacy.helperText':
    'Include what happened, how the incident was identified, what personal information was involved and how long has the personal information been exposed for.',
  'breach.tell.us.more.breachDetails.helperText':
    'Include what happened, how the incident was identified, what the main issue is, potential impacts to customers and/or QBE and a relevant timeline of events if necessary.',

  'breach.tell.us.more.otherDetails.heading': 'Other Details',
  'breach.tell.us.more.otherDetails.customersAffected': 'Have any customers been affected?',
  'breach.tell.us.more.otherDetails.numberOfcustomer': 'How many customers have been affected?',
  'breach.tell.us.more.otherDetails.numberOfcustomer.placeholder': 'Number of customers',
  'breach.tell.us.more.otherDetails.financialLoss': 'Have they incurred a financial loss?',
  'breach.tell.us.more.otherDetails.estimatedLoss': 'Estimate the financial loss for all affected customers',
  'breach.tell.us.more.otherDetails.estimatedLoss.placeholder': 'Estimated loss',
  'breach.tell.us.more.otherDetails.product': 'Which product does the incident/breach relate to?',
  'breach.tell.us.more.otherDetails.placeholder': 'Product',
  'breach.tell.us.more.otherDetails.policyNumber': 'Enter the impacted policy number(s), if known',
  'breach.tell.us.more.otherDetails.policyNumber.infoIcon':
    'Use a comma between each number and if a large number of policies are involved, please contact your QBE representative directly',
  'breach.tell.us.more.otherDetails.claimNumber': 'Enter the impacted claim number(s), if known',
  'breach.tell.us.more.otherDetails.claimNumber.infoIcon':
    'Use a comma between each number and if a large number of claims are  involved, please contact your QBE representative directly',

  'breach.tell.us.more.resolution.heading': 'Resolution Details',
  'breach.tell.us.more.resolution.isResolved': 'Has the incident/breach been resolved?',
  'breach.tell.us.more.resolution.dateResolved': 'What date was the incident/breach resolved?',
  'breach.tell.us.more.resolution.resolutionDetails': 'How have you attempted to resolve this incident/breach?',
  'breach.tell.us.more.resolution.resolutionDetails.infoText': 'Describe any actions taken to correct',
  'breach.tell.us.more.resolution.resolutionDetails.isResolved.helperText':
    'Include details of corrective actions, preventative actions and relevant dates the actions were taken.',
  'breach.tell.us.more.resolution.resolutionDetails.isNotResolved.helperText':
    'Include when do you expect it to be resolved by and how.',
  'breach.tell.us.more.resolution.resolutionDetails.dataPrivacy.helperText':
    'Include details of how privacy incident has been contained, e.g. have we received confirmation from an unintended recipient that an email has been deleted. Also outline any actions to prevent re-occurrence.',

  'Income.details.formHeading': 'Income / Expenses',
  'Income.details.summary': 'Income / Expenses',
  'Income.details.heading': 'Other income details',
  'Income.details.incomeHeading': 'Income details',
  'Income.details.incomeStatus': 'Does the customer have any other forms of income?',
  'Income.details.incomeType': 'Please select the type of income',
  'Income.details.incomeType.label': 'Other income type',
  'Income.details.incomeDescription': 'Enter a description of the income',
  'Income.details.incomeDescription.label': 'Description',
  'Income.details.incomeAmount': 'How much does the customer earn per month from this income?',
  'Income.details.incomeAmount.label': 'Income per month',

  'Income.details.addIncome.label': 'Add another income',
  'Income.details.removeIncome.label': 'Remove',
  'Income.details.submit.label': 'Continue',

  'Income.summary.incomeType': 'Other income type',
  'Income.summary.incomeAmount': 'Income per month',
  'Income.summary.incomeDescription': 'Description',

  'Income.details.incomeAmountInfo': 'Please use Australian dollar',
  'Income.details.header': 'Income/Expenses summary',
  'Expense.details.formHeading': 'Please enter the customer’s monthly expenses',
  'Expense.details.heading': 'Expense details',
  'Expense.details.label.rent': 'Rent/Mortgage',
  'Expense.details.label.child': 'Child support',
  'Expense.details.label.otherLoan': 'Other loan',
  'Expense.details.label.motor': 'Motor vehicle',
  'Expense.details.label.credit': 'Credit card',
  'Expense.details.label.living': 'Living costs',
  'Expense.details.label.util': 'Utilities',
  'Expense.details.label.school': 'School fees',
  'Expense.details.label.hospital': 'Hospital/medical costs',
  'Expense.details.label.insurance': 'Insurance',
  'Expense.details.label.other': 'Other',
  'Expense.details.declaration.heading': 'Declaration',
  'Expense.details.declaration.text': 'I/We declare that the information provided is true and correct.',
  'Expense.details.continue': 'Continue',
  'Expense.modal.title': 'Important information',
  'Expense.modal.submit': 'Submit',
  'Expense.modal.content': `<div>Please send relevant supporting information to:</div>
     <ul>
       <li>
         Email: <a href="mailto:hardshipsupport@qbe.com">hardshipsupport@qbe.com</a>
       </li>
 
       <li>Post: Financial Hardship Support, PO Box 84, Lismore NSW 2480</li>
     </ul>
 
     <div>The following documents may be required if they are relevant to the customer’s circumstances:</div>
     <br />
 
     <ul>
       <li>Copies of most recent payslips</li>
       <li>Copies of most recent Centrelink statements</li>
       <li>Letter from former employer confirming loss of employment</li>
       <li>
         Letter from charitable organisation regarding loss of employment or inability to provide for basic necessities
       </li>
       <li>Bank notice regarding unpaid overdraft or repossession of mortgaged property</li>
       <li>Eviction notice</li>
       <li>Copies of unexpected bills/payments</li>
       <li>Pending disconnection of essential service/s</li>
       <li>Repossession notice of essential items e.g. car, motorcycle</li>
       <li>Funeral expenses</li>
       <li>Notice of impending legal action</li>
       <li>Family law court document regarding changes</li>
       <li>
         Letter from doctor confirming inability to earn income due to disability, injury, illness or caring for a sick
         family member
       </li>
       <li>Overdue medical bills</li>
     </ul>`,

  'complaint.details.attachment.infoText': 'Allowed file types are:',

  'internalErrorMessage.title': 'Error',
  'internalErrorMessage.description': `Something has gone wrong. We apologise for any inconvenience. Please try again later or give us a call on
  1300 650 503.`,

  'addressAutocomplete.unavailable':
    'Address search is unavailable right now, please enter the address manually via the link',
  'addressAutocomplete.includeUnitNumber': 'Remember to include your unit number as well as your street number',
  'addressAutocomplete.cantFindTheAddress': 'Can’t find the address?',
  'addressAutocomplete.enterItManually': 'Enter it manually',
  'addressAutocomplete.addressSearchIncludeUnitNumber': 'If applicable, include your unit number',
  'addressAutocomplete.validValueErrorMessage': 'Please enter a valid value',
  'addressAutocomplete.invalidPostcodeErrorMessage': 'Invalid postcode',
  'addressAutocomplete.invalidCharactersErrorMessage':
    "For security reasons, only the following special characters are allowed: - / , . ' & ()",
  'contactNumber.mobile': 'Mobile phone',
  'contactNumber.other': 'Other phone',
  'contactNumber.home': 'Home phone',

  'contactPreferred.email': 'Email',
  'contactPreferred.post': 'Post',
  'contactPreferred.phone': 'Phone',

  'address.country': 'Country',
  'address.streetAddress': 'Street address',
  'address.suburb': 'Suburb',
  'address.state': 'State',
  'address.postcode': 'Postcode',

  'alertBanner.defaultErrorMsg':
    'Something has gone wrong. We apologise for any inconvenience. Please try again later or give us a call on 1300 650 503.',
  'alertBanner.defaultTitle': 'Submission unsuccessful',

  'next.label': 'Next',
  'continue.label': 'Continue',
  'contactUs.normal.subtitle': 'Contact us',
  'contactUs.normal.number': '1300 650 503',
  'contactUs.hardship.subtitle': 'Contact QBE Financial Hardship Support',
  'contactUs.hardship.number': '1300 902 417',
} as const;
